import { useQuery } from 'react-query';
import { AxiosResponse } from 'axios';
import { useRouter } from 'next/router';

import { getPopularProduct } from 'services/product.service';

export const QueryPopularProductsKey = 'getPopularProducts';

const usePopularProducts = (options: Record<string, any>, currency?: string) => {
  const { locale } = useRouter();
  return useQuery(`${QueryPopularProductsKey}${currency}${locale}`, () => getPopularProduct(currency, locale)
    .then((result: AxiosResponse<Product.Item[]>) => result.data), {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    ...options,
  });
};

export default usePopularProducts;
